<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Portal Overview
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row" v-if="rows.length">
        <div class="col-xs-16">
          <portal-table :rows="rows" :year="year" :target-metric="targetMetric"></portal-table>
        </div>

        <div class="col-xs-8">
          <portal-chart :rows="rows" :loading="loading"></portal-chart>
        </div>
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import PortalChart from '@/pages/Dashboards/Advertisement/Panels/PortalOverview/PortalChart'
import PortalTable from '@/pages/Dashboards/Advertisement/Panels/PortalOverview/PortalTable'

export default {
  components: {LoadingSpinner, PortalChart, PortalTable},

  mixins: [SaveHeight],

  props: ['year', 'targetMetric'],

  data() {
    return {
      loading: true,
      rows: []
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      this.getDataPromise()
          .then(response => {
            this.rows = response.data.data.map(row => {
              row.index = row[this.targetMetric] ? row.ad_value_after_costs / row[this.targetMetric] * 100 : null

              row.difference = row.ad_value_after_costs - row[this.targetMetric]

              return row
            })

            this.loading = false
          })
    },

    getDataPromise() {
      return http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'ad_value_after_costs'},
          {name: this.targetMetric},
        ],
        dimensions: [
          {name: 'portal_id'},
          {name: 'portal_name'},
          {name: 'portal_color'},
        ],
        filters: [
          {dimension: 'publish_year', operator: '=', value: this.year},
        ]
      })
    }
  }
}
</script>
